
import XButton from 'vux/src/components/x-button/index.vue'

export default {
data(){
return{
hosCode:null
}
},
components: {XButton},
computed: {},
methods: {
jumpToZgTd(){
this.$router.push({ path: 'SystemSurvey', query: { personname: 200, hosCode:this.hosCode}});
},
jumpToHzTd(){
this.$router.push({ path: 'SystemSurvey', query: { personname: 300, hosCode:this.hosCode}});
},

},
mounted(){

this.hosCode =this.$route.query.hosCode;

}
}



// WEBPACK FOOTER //
// ./src/project/ValuationProject/SystemSurveyIndex.vue